module Client.Admin.ResetPassword.Edit

open Shared
open Client
open Illy.SafeStack.Client
open Fable.React
open Fable.React.Props
open Shared.PasswordReset.Admin.Edit

type Model = 
    {
        UserId: UserId 
        GeneralError: string option
        Saving: bool
    }

type Msg = 
    | ApiError of ApiError
    | SaveResult of FailureReason option
    | CloseOverlay  
    | SaveClicked 

type Event = 
    | CloseOverlay 
    | ApiError of ApiError 
    | SaveSuccessful of notification: string 

let init userId = 
    {
        UserId = userId 
        GeneralError = None
        Saving = false
    }, []

let update msg model = 
    match msg with 
    | Msg.ApiError err -> model, err |> ApiError |> SideEffect.Event 
    | Msg.CloseOverlay -> model, CloseOverlay |> SideEffect.Event 
    | SaveClicked -> 
        {model with Saving = true},
        Api.secureCall<IResetPasswordFromAdminApi,_,_,_> SecuredRoute.Admin (fun api -> api.resetPassword)  model.UserId SaveResult Msg.ApiError
        |> SideEffect.Cmd
    | SaveResult reason -> 
        match reason with 
        | None
        | Some NothingToDo -> model, "User password was reset successfully." |> Event.SaveSuccessful |> SideEffect.Event

let view model dispatch = 
    jQueryUI.modal "Reset the User's Password" 50 Msg.CloseOverlay dispatch (Some 800) [
        yield jQueryUI.illy_info [
            str "Are you sure you want to reset the password for this user?"
        ]
        yield UI.renderError model.GeneralError
        yield! UI.saveControls (Some "Reset password") false model.Saving SaveClicked Msg.CloseOverlay dispatch
    ]